import { clickOutside } from './clickOutside';
import { resizeSelf } from './resizeSelf';
import sticky from './sticky';
import { topStickAfter } from './topStickAfter';
import { leftClipText } from './leftClipText';
import { tooltip } from './tooltip';

export const directives = {
    clickOutside,
    sticky,
    resizeSelf,
    topStickAfter,
    leftClipText,
    tooltip,
};
